import type {
	TopologyEdgeRelocationCandidate,
} from '../../../../../types/reference/sketch-entity-reference/TopologyEdgeRelocationService';
import type {
	TopologySelectionRuntimeSourceSnapshot,
} from '../../../../../types/reference/sketch-entity-reference/TopologySelectionRuntimeSourceSnapshot';

/**
 * 把完整 topology 重定位候选收口为命令会话可安全传递的纯数据快照。
 */
export class TopologySelectionRuntimeSourceSnapshotFactory {
	/**
	 * 创建当前选择使用的 topology 来源快照。
	 *
	 * 数组与嵌套对象全部复制，确保场景候选后续更新不会修改已经编译的命令输入；
	 * FeatureLine 和完整 topology snapshot 不在返回接口中，因此不会穿过 UI/Create seam。
	 *
   * @param candidate 已按所属 Body 确认的边候选，可来自 Worker 精确查询或 sidecar 采样路径。
	 * @returns 仅包含首次投影所需数据的独立快照。
	 */
	public create(
		candidate: TopologyEdgeRelocationCandidate,
	): TopologySelectionRuntimeSourceSnapshot {
		return {
			edgeIndex: candidate.edgeIndex,
			...(candidate.exactConic ? {exactConic: structuredClone(candidate.exactConic)} : {}),
			...(candidate.topologyMemberId
				? {topologyMemberId: candidate.topologyMemberId}
				: {}),
			...(candidate.persistentRef
				? {persistentRef: candidate.persistentRef}
				: {}),
			...(candidate.subEntityId
				? {subEntityId: candidate.subEntityId}
				: {}),
			...(candidate.curveKind
				? {curveKind: candidate.curveKind}
				: {}),
			...(candidate.worldLine
				? {
					worldLine: {
						start: [...candidate.worldLine.start],
						end: [...candidate.worldLine.end],
					},
				}
				: {}),
			...(candidate.sampledPointWorlds
				? {
					sampledPointWorlds: candidate.sampledPointWorlds.map(point => (
						[point[0], point[1], point[2]]
					)),
				}
				: {}),
			...(candidate.endpointAnchorRefs
				? {
					endpointAnchorRefs: {
						...(candidate.endpointAnchorRefs.start
							? {start: candidate.endpointAnchorRefs.start}
							: {}),
						...(candidate.endpointAnchorRefs.end
							? {end: candidate.endpointAnchorRefs.end}
							: {}),
					},
				}
				: {}),
		};
	}
}
